// extracted by mini-css-extract-plugin
export var jtbdCard = "jtbd-card-module--jtbd-card--c4e78";
export var jtbdCardUrl = "jtbd-card-module--jtbd-card--url--90515";
export var jtbdCard__body = "jtbd-card-module--jtbd-card__body--532d3";
export var jtbdCard__content = "jtbd-card-module--jtbd-card__content--899e2";
export var jtbdCard__eyebrow = "jtbd-card-module--jtbd-card__eyebrow--b5443";
export var jtbdCard__headline = "jtbd-card-module--jtbd-card__headline--5f501";
export var jtbdCard__img = "jtbd-card-module--jtbd-card__img--98ab5";
export var jtbdCard__link = "jtbd-card-module--jtbd-card__link--4d4c5";
export var mt0 = "jtbd-card-module--mt-0--e55e3";
export var mt1 = "jtbd-card-module--mt-1--498b3";
export var mt2 = "jtbd-card-module--mt-2--a080d";
export var mt3 = "jtbd-card-module--mt-3--cd2f4";
export var mt4 = "jtbd-card-module--mt-4--f0a49";
export var mt5 = "jtbd-card-module--mt-5--105e4";
export var mt6 = "jtbd-card-module--mt-6--cd5e4";